import { Control, useController } from "react-hook-form";
import styled from "styled-components";
import { FC } from "react";
import { AmountItem, AmountDropdown, TextInputErrorVariant } from "../ui-kit";
import { CurrencyCodes } from "@fena/toolkit-types";
import { CurrencyItem } from "../../constants/currencies";
// import {
//   currencies,
//   noUsdCurrency,
//   oneCurrency,
// } from "../../constants/currencies";

const Container = styled.div`
  padding-top: 10px;
  width: 100%;
`;

interface AmountDropDownFormFieldProps {
  name: string;
  currencyName?: string;
  className?: string;
  control?: Control<any>;
  label: string;
  required?: boolean;
  disabled?: boolean;
  currencyValue?: CurrencyCodes;
  items?: CurrencyItem[];
  onBlur?: () => void;
  onDropdownChange?: (val: CurrencyItem) => void;
  separateCurrencyDropdownChange?: boolean;
}

export const AmountDropDownFormField: FC<AmountDropDownFormFieldProps> = ({
  name,
  className,
  control,
  label,
  disabled,
  required,
  currencyValue,
  currencyName,
  items,
  onBlur,
  onDropdownChange,
  separateCurrencyDropdownChange,
}) => {
  const { field: currencyField } = useController({
    name: currencyName ?? "",
    control,
  });

  const {
    field,
    fieldState: { error },
  } = useController({ name, control });

  const handleChange = (val: AmountItem) => {
    field.onChange(val.value);
    currencyField.onChange(val?.currency.currencyCode);
  };

  const handleCurrencyChange = (currency: CurrencyItem) => {
    currencyField.onChange(currency.currencyCode);
    onDropdownChange?.(currency);
  };

  const variant = () => {
    if (error != null) {
      return TextInputErrorVariant.ERROR;
    } else {
      return TextInputErrorVariant.DEFAULT;
    }
  };

  return (
    <Container className={className}>
      <AmountDropdown
        variant={variant()}
        label={label}
        onChange={handleChange}
        items={items}
        error={error?.message}
        value={field.value}
        currencyValue={currencyValue ?? currencyField.value}
        required={required}
        disabled={disabled}
        onDropdownChange={
          separateCurrencyDropdownChange ? handleCurrencyChange : undefined
        }
        separateCurrencyDropdownChange={separateCurrencyDropdownChange}
        onBlur={onBlur ?? field.onBlur}
      />
    </Container>
  );
};
